module.exports = __webpack_public_path__ + "img/KYbg.4e394605.jpg";